export const BATCH_MODEL_TYPE_SHIPMENT_BATCH = 'shipment-batch'
export const BATCH_MODEL_TYPE_GOODS_RECEIPT = 'goods-receipt'
